import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { MeetStrangersBanner, SROnlyH1 } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function MeetStrangersOnline() {
  return (
    <>
      <SEO
        title="Meet Strangers Online - Talkvee"
        description="A modern way to meet strangers online. Ad-free, quick guest login, interest matching, and fun games to keep chats flowing."
        pathname="/meet-strangers-online"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Meet Strangers Online", "item": "https://talkvee.com/meet-strangers-online" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <MeetStrangersBanner />
        <section className="landing-hero">
          
          <h1 className="landing-title">Meet Strangers Online — Safe & Simple</h1>
          <p className="landing-subtitle">
            Talkvee helps you meet new people without the noise: guest login, interest
            matching, and quick challenges that make conversations natural.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>
        <FAQSection
          items={[
            {
              q: "Can I really make friends online with Talkvee?",
              a: "Yes! Many users meet new people through shared interests, trivia games, or just fun conversations."
            },
            {
              q: "How do I start meeting strangers online?",
              a: "Simply click 'Start Chatting'. You can join as a guest or log in socially."
            },
            {
              q: "Is it free to meet strangers?",
              a: "Absolutely. Talkvee is free and ad-free."
            },
            {
              q: "Do you have games to break the ice?",
              a: "Yes! From trivia battles to laugh challenges, games make meeting new people easier."
            },
            {
              q: "What devices are supported?",
              a: "Desktop, laptop, and mobile browsers are supported. You can also install Talkvee as a PWA."
            },
            {
              q: "Is my data safe?",
              a: "We don’t record conversations or sell user data. Privacy and safety come first."
            },
            {
              q: "Can I share fun moments?",
              a: "Coming soon: VeeClips — a way to share short clips (with consent) of your funniest or best chat moments."
            }
          ]}
        />

      </div>
    </>
  );
}